import { Validators, ValidatorFn } from '@angular/forms';
import { FORM_VALIDATION_NAMES } from '../../../providers/myria/app-variables';

export class Category {
  Title: string;
  Fields: FieldModel[];

  public constructor() {
    this.Title = '';
    this.Fields = [];
  }
}

export class FieldModel {
  FieldId: number | string;
  Label: string;
  Type: string;
  HasAsyncValues: boolean;
  Options: any[];
  options: any[];
  DependsOn: number;
  FieldValidations: any[];
  Value: any;
  value: any;
  PhoneLogin: any;
  Readonly: boolean;
  Parent: number | string;
  ShowOnParentValues?: string[];

  public constructor(options: {
    DependsOn?: number,
    FieldId?: number | string,
    HasAsyncValues?: boolean,
    Label?: string,
    FieldValidations?: FieldValidations[],
    Options?: any[],
    Type?: string,
    Value?: any,
    PhoneLogin?: any,
    Readonly?: boolean,
    Parent?: number | string,
    ShowOnParentValues?: string[]
  }) {
    this.DependsOn = options.DependsOn || undefined;
    this.FieldId = options.FieldId || 0;
    this.HasAsyncValues = options.HasAsyncValues || false;
    this.Label = options.Label || '';
    this.FieldValidations = this.buildValidators(options.FieldValidations || []);
    this.Options = options.Options || [];
    this.Type = options.Type || '';
    this.Value = options.Value;
    this.PhoneLogin = options.PhoneLogin || '';
    this.Readonly = options.Readonly;
    this.Parent = options.Parent || undefined;
    this.ShowOnParentValues = options.ShowOnParentValues || [];
  }

  buildValidators(fieldsValidators: any[]) {
    let validators = [];
    if (fieldsValidators.length > 0) {
      for (let validator of fieldsValidators) {
          validators.push(this.getValidator(validator));
      }
    }
    return validators;
  }

  getValidator(fieldValidator: any) {
    let validator: ValidatorFn;
    switch (fieldValidator.Type.toLowerCase()) {
      case FORM_VALIDATION_NAMES.REQUIRED:
      fieldValidator.Value = true;
      validator = Validators.required;
      break;
      case FORM_VALIDATION_NAMES.REGEX:
      validator = Validators.pattern(fieldValidator.Value);
      break;
      case FORM_VALIDATION_NAMES.MIN_LENGTH:
      validator = Validators.minLength(parseInt(fieldValidator.Value));
      break;
      case FORM_VALIDATION_NAMES.MAX_LENGTH:
      validator = Validators.maxLength(parseInt(fieldValidator.Value));
      break;
      case FORM_VALIDATION_NAMES.MIN_VALUE:
      validator = Validators.min(parseInt(fieldValidator.Value));
      break;
      case FORM_VALIDATION_NAMES.MAX_VALUE:
      validator = Validators.max(parseInt(fieldValidator.Value));
      break;
    }

    return validator;
  }
}

export class FieldValidations {
  Name: string;
  Value: string;
  Message: string;

  public constructor() {}
}



// WEBPACK FOOTER //
// ./src/model/myria/app/DynamicForm.ts